import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import App from './App.tsx';
import './index.css';

// Initialize monitoring and analytics
import { initializeSentry } from './lib/sentry';
import { initializeAnalytics } from './lib/analytics';

// Initialize Sentry as early as possible
initializeSentry();

// Initialize PostHog analytics
initializeAnalytics();

createRoot(document.getElementById('root')!).render(
  <StrictMode>
    <App />
  </StrictMode>
);
